export class FormFillingError extends Error {
  constructor() {
    super()
    this.name = 'Form Filling Error'
  }

  cannotMakeQuestionValid(questionKey: string, retries: number) {
    this.message = `The question with key ${questionKey} could not become valid after ${retries} random fillings. Please double check that the conditions (rules, min/max, et cetera...) applied to the question and the whole survey make sense.`
    return this
  }
}
